import * as metrics from "./metrics";

export default () => ({
  brand: store.getState().currentBrand.id,
  impersonating: sessionStorage.getItem("impersonating"),
  "X-Requested-With": "XMLHttpRequest",
  "X-Metrics-Session": metrics.getSessionId(),
});
